import React from 'react';

import AccountSecurity from './AccountSecurity.jsx';
import ArticleModal from './ArticleModal.jsx';
import ArticleReaction from './ArticleReaction.jsx';
import ArticleBookmark from './ArticleBookmark.jsx';
import AssetChart from './AssetChart.jsx';
import AssetList from './AssetList.jsx';
import AssetResearch from './AssetResearch.jsx';
import AssetUpdated from './AssetUpdated.jsx';
import AssetsLinks from './AssetsLinks.jsx';
import CheckoutDurationSelectorWebinar from './CheckoutDurationSelectorWebinar.jsx';
import DailySnapshotsFeed from './DailySnapshotsFeed.jsx';
import Dashboard from './Dashboard.jsx';
import DonutChart from './DonutChart.jsx';
import EditAccount from './EditAccount.jsx';
import HeadlineAnalysisFeed from './HeadlineAnalysisFeed.jsx';
import NFTCollectionList from './NFTCollectionList.jsx';
import NFTHistoricalRevenue from './NFTHistoricalRevenue.jsx';
import NFTPriceChart from './NFTPriceChart.jsx';
import NFTTokenUtility from './NFTTokenUtility.jsx';
import TradingViewChart from './TradingViewChart.jsx';
import ProductForm from './ProductForm.jsx';


 const loader = [
    new AccountSecurity(),
    new ArticleModal(),
    new ArticleReaction(),
    new ArticleBookmark(),
    new AssetChart(),
    new AssetList(),
    new AssetResearch(),
    new AssetUpdated(),
    new AssetsLinks(),
    new CheckoutDurationSelectorWebinar(),
    new DailySnapshotsFeed(),
    new Dashboard(),
    new DonutChart(),
    new EditAccount(),
    new HeadlineAnalysisFeed(),
    new NFTCollectionList(),
    new NFTHistoricalRevenue(),
    new NFTPriceChart(),
    new NFTTokenUtility(),
    new ProductForm(),
    new TradingViewChart()
  ];

export default loader;
